import React, { useRef, useState, forwardRef, useImperativeHandle } from 'react'

interface PinProps {
  onChange: (pin: string) => void
  type: 'pin' | 'token'
}
export interface PinHandle {
  clear: () => void
}

export const Pin = forwardRef<PinHandle, PinProps>(({ onChange, type }, ref) => {
  const length = type === 'pin' ? 4 : 6
  const [pin, setPin] = useState<string>(''.padEnd(length, ' '))
  const inputsRef = useRef<Array<HTMLInputElement | null>>([])

  const handleChange = (index: number, value: string) => {
    if (!/^\d?$/.test(value)) return

    const pinArr = pin.split('')
    pinArr[index] = value
    const newPin = pinArr.join('')
    setPin(newPin)
    onChange(newPin.replace(/ /g, ''))

    if (value && index < length - 1) {
      inputsRef.current[index + 1]?.focus()
    }
  }

  const handleKeyDown = (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (e.key === 'Backspace' && !pin[index] && index > 0) {
      inputsRef.current[index - 1]?.focus()
    }
  }

  const clear = () => {
    setPin(''.padEnd(length, ' '))
    onChange('')
    // focar no primeiro input
    requestAnimationFrame(() => {
      inputsRef.current[0]?.focus()
    })
  }

  useImperativeHandle(ref, () => ({ clear }))

  return (
    <div className="flex w-full justify-center gap-4">
      {Array.from({ length }).map((_, idx) => (
        <input
          placeholder={ type === 'pin' ? '1' : 'X' }
          key={idx}
          ref={el => {
            inputsRef.current[idx] = el
          }}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={
            pin[idx] === ' '
              ? ''
              : type === 'token'
                ? pin[idx]
                : pin[idx]
                  ? '*'
                  : ''
          }
          onChange={e => handleChange(idx, e.target.value)}
          onKeyDown={e => handleKeyDown(idx, e)}
          className={`h-[60px] w-[60px] rounded border border-[#989898] text-center text-xl tracking-widest ${type === 'token' ? 'max-[500px]:h-[44px] max-[500px]:w-[44px]' : ''}`}
        />
      ))}
    </div>
  )
})

Pin.displayName = 'Pin'
